export default __webpack_public_path__ + "static/media/state-hoisting.e89f8908.gif";